/*!
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 */

var iconCurrentId = 0;

// the semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
;(function ($, window, document, undefined) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'icons',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = $(element);
        /*
        options = {
            'size': 256,
            'data': [
                'icoGen/gen.php?file=F:/Web/cd_activity/tpl/icon/favicon.ico&size=256',
                {
                    'src': 'icoGen/gen.php?file=F:/Web/plumedor/tpl/icon/favicon.ico&size=256',
                    'size': 50,
                    'x': 0,
                    'y': 0
                },
                {
                    'src': 'icoGen/gen.php?file=F:/Web/plumedor/tpl/icon/favicon.ico&size=256',
                    'size': 50,
                    'x': 50,
                    'y': 50
                },
                {
                    'src': 'icoGen/gen.php?file=F:/Web/plumedor/tpl/icon/favicon.ico&size=256',
                    'size': 50,
                    'x': 100,
                    'y': 100
                }
            ]
        };
        */

        //this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this._element = null;
        this.id = 'icon--' + iconCurrentId;
        this.uid = null;
        iconCurrentId++;
        this.options = this.optionsFix(options);
        this.data = this.format(this.options);
        this.element.attr('id', this.id);
        this.renderMulti();
    }

    Plugin.prototype.action = function (action, options) {
        switch (action) {
            case 'refresh':
                this.refresh();
                break;
            case 'update':
                this.update();
                break;
            case 'remove':
                this.remove(options);
                break;
            default:
                break;
        }
    };

    Plugin.prototype.renderMulti = function () {
        var selfIcon = this;
        var output = $('#' + selfIcon.id);
        var mode = 'edit';
        if (!output.length) {
            output = $('<div class="ico__group" id="' + selfIcon.id + '" ' + ((this.data.sizeForce) ? 'style="width: ' + this.data.size + 'px; height: ' + this.data.size + 'px;"' : '') + '></div>');
            mode = 'add';
        } else {
            output.html('');
        }

        $.each(this.data.data, function (index, item) {
            output.append(selfIcon.render(item));
        });

        if (mode == 'add') {
            selfIcon.element.html(output);
        }
    };

    Plugin.prototype.render = function (data) {
        var selfIcon = this;
        var addonClass = [];
        var uid = 'ico--' + hashCode(data.src);

        let output = '<span class="ico ' + ((data.classes) ? data.classes : '') + ' ico--' + data.fill + ' ico--format--' + data.ext.toLowerCase() + ' ico--size--' + data.globalSize + ' ' + addonClass.join(' ') + '" data-id="' + uid + '"><span class="ico__inner">';

        switch (data.mode) {
            case 'char':
                output += selfIcon.renderChar(data);
                break;
            case 'font':
                output += selfIcon.renderFont(data);
                break;
            case 'fa':
                output += selfIcon.renderFa(data);
                break;
            case 'svg-s':
                output += selfIcon.renderSvgSymbol(data);
                break;
            case 'svg':
                output += selfIcon.renderSvg(data);
                break;
            case 'img':
                output += selfIcon.renderImg(data);
                break;
            default:
                output += selfIcon.renderImg(data);
                break;
        }

        output += '</span></span>';

        setTimeout(() => {
            this.afterRender(data, uid);
        }, 1);
        return output;
    };

    Plugin.prototype.renderChar = function (data) {
        return '<i class="ico__img" style=" font-weight: bold; ' +
            ((data.size) ? 'padding:' + (100 - data.size) + '%;' : '') +
            ((data.x) ? ' top:' + (data.x) + '%; ' : '') +
            ((data.y) ? ' left:' + (data.y) + '%; ' : '') +
            '">' + data.src + '</i>';
    };

    Plugin.prototype.renderFont = function (data) {
        var fontName = data.fontName || data.src.replace('font-', '');
        return '<span class="ico__img" style="font-family: \'' + fontName + '\', sans-serif; display: flex; align-items: center; justify-content: center; font-weight: bold; line-height: 1; ' +
            ((data.size) ? 'font-size:' + (data.size * 0.3) + 'px;' : '') +
            ((data.x) ? ' top:' + (data.x) + '%; ' : '') +
            ((data.y) ? ' left:' + (data.y) + '%; ' : '') +
            '">A</span>';
    };

    Plugin.prototype.renderFa = function (data) {
        return '<i class="ico__img '+((opt('icon.fa_weight'))?opt('icon.fa_weight'):'fa')+' ' + data.src + '" style="' +
            ((data.size) ? 'padding:' + (100 - data.size) + '%;' : '') +
            ((data.x) ? ' top:' + (data.x) + '%; ' : '') +
            ((data.y) ? ' left:' + (data.y) + '%; ' : '') +
            '"></i>';
    };

    Plugin.prototype.renderSvgSymbol = function (data) {
        return '<svg class="ico__img" viewBox="0 0 256 256"  style="' +
            ((data.size) ? ' height:' + (data.size) + '%; ' : '') +
            ((data.size) ? ' width:' + (data.size) + '%; ' : '') +
            ((data.x || data.x === 0) ? ' top:' + (((100 - data.size) * data.x) / 100) + '%; ' : '') +
            ((data.y || data.y === 0) ? ' left:' + (((100 - data.size) * data.y) / 100) + '%; ' : '') +
            ((data.bg && i == 0) ? ' background-color: ' + data.bg + '; ' : '') +
            '"><use xlink:href="' + data.src + '" x="0" y="0" /></svg>';
    };

    Plugin.prototype.renderSvg = function (data) {
        var shapeCls = (data.shape && data.shape !== 'default') ? ' ico__img--' + data.shape : '';
        return '<img src="' + data.src + '" class="ico__img svg' + shapeCls + '" style="' +
            ((data.size) ? ' height:' + (data.size) + '%; ' : '') +
            ((data.size) ? ' width:' + (data.size) + '%; ' : '') +
            ((data.x || data.x === 0) ? ' top:' + (((100 - data.size) * data.x) / 100) + '%; ' : '') +
            ((data.y || data.y === 0) ? ' left:' + (((100 - data.size) * data.y) / 100) + '%; ' : '') +
            ((data.bg && i == 0) ? ' background-color: ' + data.bg + '; ' : '') +
            '" />';
        /*
        return '<svg class="ico__img" viewBox="0 0 256 256"  style="'+
            ((data.size)?' height:'+(data.size)+'%; ':'')+
            ((data.size)?' width:'+(data.size)+'%; ':'')+
            ((data.x || data.x === 0)?' top:'+(((100 - data.size)*data.x)/100)+'%; ':'')+
            ((data.y || data.y === 0)?' left:'+(((100 - data.size)*data.y)/100)+'%; ':'')+
            ((data.bg && i == 0)?' background-color: '+data.bg+'; ':'')+
            '"><use xlink:href="'+data.src+'" x="0" y="0" /></svg>';
         */
    };

    Plugin.prototype.renderImg = function (data) {
        var ext = (data.ext || (data.file ? fileExtention(data.file) : (data.src ? fileExtention(data.src) : '')) || '').toLowerCase();
        var isSvg = ext === 'svg';
        var shapeCls = (data.shape && data.shape !== 'default') ? ' ico__img--' + data.shape : '';
        return '<img src="' + data.src + '" class="ico__img' + (isSvg ? ' svg' : '') + shapeCls + '" style="' +
            ((data.size) ? ' height:' + (data.size) + '%; ' : '') +
            ((data.size) ? ' width:' + (data.size) + '%; ' : '') +
            ((data.x || data.x === 0) ? ' top:' + (((100 - data.size) * data.x) / 100) + '%; ' : '') +
            ((data.y || data.y === 0) ? ' left:' + (((100 - data.size) * data.y) / 100) + '%; ' : '') +
            ((data.bg && i == 0) ? ' background-color: ' + data.bg + '; ' : '') +
            '" />';
    };

    Plugin.prototype.renderBg = function (data) {
        var shapeCls = (data.shape && data.shape !== 'default') ? ' ico__img--' + data.shape : '';
        return '<span class="ico__img' + shapeCls + '" style="' +
            ((data.size) ? ' height:' + (data.size) + '%; ' : '') +
            ((data.size) ? ' width:' + (data.size) + '%; ' : '') +
            ((data.x || data.x === 0) ? ' top:' + (((100 - data.size) * data.x) / 100) + '%; ' : '') +
            ((data.y || data.y === 0) ? ' left:' + (((100 - data.size) * data.y) / 100) + '%; ' : '') +
            ((data.bg && i == 0) ? ' background-color: ' + data.bg + '; ' : '') +
            'background-image:url(\'' + data.src + '\');' +
            '"></span>';
    };

    Plugin.prototype.optionsFix = function (data) {
        // data
        if (typeof data.data == 'object') {
            if (data.data && data.data.constructor.name != 'Array') {
                data.data = [data.data]
            }
        } else if (data.data) {
            data.data = [data.data]
        } else {
            data.data = {
                'src': 'file-page-empty'
            };
        }

        return data;
    }

    Plugin.prototype.format = function (data) {
        var selfIcon = this;

        // size
        if (!data.size) data.size = 'hd';
        if (!data.sizeForce && data.sizeForce !== false) data.sizeForce = false;
        switch (data.size) {
            case 'hd':
                data.size = '256';
                break;
            case 'auto':
            case 'medium':
                data.size = '64';
                break;
            case 'small':
                data.size = '24';
                break;
            case 'tiny':
                data.size = '16';
                break;
        }

        $.each(data.data, (index, item) => {
            if (!item) item = '';
            else if (typeof item == 'object') {
                if (item.src === undefined) item.src = '';
                if (item.alt === undefined) item.alt = '';
            }


            // str convertion
            if (typeof item != 'object') {
                item = {
                    'src': item
                };
            } else if (item.tiny || item.small || item.medium || item.hd) {
                if (data.size > 64 && item.hd) item = item.hd;
                else if (data.size > 24 && item.medium) item = item.medium;
                else if (data.size > 16 && item.small) item = item.small;
                else item = item.tiny;

                item = {
                    'src': item
                };
            }
            // image reference
            if (item.src && left(item.src, 4) == 'img-' && item.src != 'img-undefined' && item.src.length > 4) {
                console.log('IMGQ');
                console.log(item.src)
                console.log(item.src.replace('img-', ''))
                selfIcon.getGalerieImage(item.src.replace('img-', ''), data.size, index);
                item.src = 'file-page-empty';
            }

            // is character
            else if (typeof item.src == 'number' || (item.src && item.src.length < 3)) {
                item.src = String(item.src);
                item.ext = 'glyph';
                item.mode = 'char';
            }

            // is email
            if (isEmail(item.src)) {
                item.src = 'https://www.gravatar.com/avatar/' + md5(item.src) + '?d=' + opt('user.avatar_default') + '&s=' + data.size;
            }

            // is file
            else if (item.src && item.src.lastIndexOf('.') != -1) {
                var ext = item.src.substr((item.src.lastIndexOf('.') + 1)).toLowerCase().split('?')[0];

                if (ext != 'jpg' && ext != 'jpeg' && ext != 'png' && ext != 'svg' && ext != 'gif' && ext != 'ico' && ext.length < 6) {
                    var meta = this.getFileTypeIcon(ext);
                    item.src = meta.icon;
                }
            }

            // is color
            else if (item.src && item.src.charAt(0) == '#' || item.src.substring(0, 3) == 'rgb') {
                item.src = selfIcon.getColorIcon(item.src);
            }
            // is FA
            else if (left(item.src, 3) == 'fa-') {
                // item.src = selfIcon.getFaIcon(item.src);
                if (opt('icon.set_mono')) item.classes = 'ico--mono';
                item.mode = 'fa';
            }
            // is font
            else if (left(item.src, 5) == 'font-') {
                item.fontName = item.src.replace('font-', '');
                item.mode = 'font';
            }
            // is Brand
            else if (left(item.src, 6) == 'brand-') {
                item.src = selfIcon.getBrandIcon(item.src);
            }
            // is theme icon
            else if (item.src.split('?')[0].split('#')[0].indexOf('/') == -1 && item.src.split('?')[0].split('#')[0].indexOf('.') == -1) {
                if (opt('icon.set_type') != 'png' && opt('icon.set_type') != 'svg' && opt('icon.set_type') != 'gif') {
                    item.src = selfIcon.convertThemeIcon(item.src);
                    // item.src = selfIcon.getFaIcon(item.src);
                    if (opt('icon.set_mono')) item.classes = 'ico--mono';
                    item.mode = 'fa';
                }
                else {
                    item.src = selfIcon.getThemeIcon(item.src, data.size);
                    if (opt('icon.set_mono')) item.classes = 'ico--mono';
                }
            }
            // is URL
            else if (item.src.indexOf('http') != -1) {

            }
            // is theme file
            else if (item.src.indexOf('themes/') == -1 && item.src.indexOf('up/') == -1 && item.src.indexOf('api/') == -1 && item.src.indexOf('admin/') == -1 && item.src.indexOf('icons/') !== 0 && item.src.indexOf('js/') == -1) {
                item.src = root + item.src;
                if (!fileExtention(item.src)) item.src = item.src + '.png';
            }

            // extract url parameter
            var splitedData = item.src.split('?');
            item.file = splitedData[0];
            if (splitedData.length == 2) {
                item.params = splitedData[1];
            }

            // file ext
            if (!item.ext) {
                item.ext = item.file.substr((item.file.lastIndexOf('.') + 1));
                item.ext = item.ext.split('#');
                item.symbol = item.ext[1];
                item.ext = item.ext[0];
            }
            if (!item.ext || item.ext.length > 5) item.ext = 'url';
            if (item.mode == 'fa') item.ext = 'glyph';

            // mode
            if (!item.mode || item.mode == 'auto') {
                if (item.ext == 'svg' && item.symbol) item.mode = 'svg';
                else if (item.ext == 'svg') item.mode = 'svg';
                else item.mode = 'bg';
            }

            if (!item.size) item.size = 100;
            // if (!item.x && item.x !== 0) item.x = 50;
            // if (!item.y && item.y !== 0) item.y = 50;
            item.src = item.file;
            if (item.params) item.src += '?' + item.params;
            if (item.shape === undefined) {
                if (data.shape) item.shape = data.shape;
                else if (selfIcon.options && selfIcon.options.shape) item.shape = selfIcon.options.shape;
            }
            if (item.shape && item.shape !== 'default') {
                if (item.shape === 'scare' || item.shape === 'square' || item.shape === 'circle') {
                    item.fill = 'cover';
                } else if (item.shape === 'rectangle') {
                    item.fill = 'contain';
                }
            } else if (item.size < 100) item.fill = 'contain';
            else if (data.fill && data.fill != 'auto') item.fill = data.fill;
            else if (!item.fill) {
                if (item.ext.toLowerCase() == 'jpg') item.fill = 'cover';
                else item.fill = 'contain';
            }
            item.globalSize = data.size;

            // console.log(item);

            data.data[index] = item;
        });

        return data;
    };

    Plugin.prototype.getFaIcon = function (data) {
        data = data.replace('fa-', '');
        return 'icons/fa5/svg/solid/' + data + '.svg';
    };

    Plugin.prototype.getBrandIcon = function (data) {
        data = data.replace('brand-', '');
        return 'icons/brand/' + data + '.svg';
    };

    Plugin.prototype.getThemeIcon = function (data, size) {
        var currentFormat = null;
        var currentSize = 0;

        $.each(opt('icon.set_sizes'), function (index, format) {
            if (currentSize < index && (index <= size || size > currentSize) || !currentSize) {
                currentFormat = format;
                currentSize = index;
            }
        });

        data = this.remapThemeIcon(data);

        if (!currentFormat) currentFormat = 'medium';

        var skinPath = 'icons/sets/';
        var path = skinPath + opt('icon.set') + '/' + currentFormat + '/' + data + '.' + opt('icon.set_type');
        if (opt('icon.set_type') == 'svg') {
            path = skinPath + opt('icon.set') + '/' + currentFormat + '.'+opt('icon.set_type')+'#'+data;
        }

        return path;
    };

    Plugin.prototype.remapThemeIcon = function (data) {
        if (!data) data = 'status-help';

        // theme name remap
        const remap = {
            "add": "action-add",
            "confirm": "action-confirm",
            "select": "action-select",
            "refresh": "arrow-do-refresh",
            "undo": "arrow-do-redo",
            "redo": "arrow-do-undo",
            "up": "arrow-up",
            "down": "arrow-down",
            "left": "arrow-left",
            "right": "arrow-right",
            "loop": "arrow-loop",
            "mail": "com-mail",
            "phone": "com-phone",
            "cellphone": "com-phone-mobile",
            "smartphone": "com-phone-smart",
            "calc": "device-calc",
            "computer": "device-computer",
            "laptop": "device-computer-laptop",
            "router": "device-computer-router",
            "server": "device-computer-server",
            "tablet": "device-computer-tablet",
            "game": "device-in-game",
            "keyboard": "device-in-keyboard",
            "mouse": "device-in-mouse",
            "printer": "device-printer",
            "screen": "device-screen",
            "signal": "device-signal",
            "cd": "device-stor-cd",
            "disk": "device-stor-disk",
            "drive": "device-stor-drive",
            "sd": "device-stor-sd",
            "usb": "device-stor-usb",
            "left": "edit-align-left",
            "center": "edit-align-center",
            "right": "edit-align-right",
            "justify": "edit-align-justify",
            "top": "edit-disp-top",
            "middle": "edit-disp-middle",
            "bottom": "edit-disp-bottom",
            "columns": "edit-columns",
            "bold": "edit-format-bold",
            "italic": "edit-format-italic",
            "strike": "edit-format-strike",
            "underline": "edit-format-underline",
            "indent": "edit-indent-more",
            "outdent": "edit-indent-less",
            "ol": "edit-list-ol",
            "ul": "edit-list-ul",
            "book": "file-book",
            "file": "file-page-empty",
            "cloud": "place-cloud",
            "home": "place-home",
            "user": "secure-user",
            "users": "secure-users",
            "bloc": "shape-bloc",
            "cross": "shape-cross",
            "feets": "shape-feets",
            "fire": "shape-fire",
            "heart": "shape-heart",
            "lightning": "shape-lightning",
            "star": "shape-star",
            "target": "shape-target",
            "bug": "shape-bug",
            "denied": "status-denied",
            "error": "status-error",
            "help": "status-help",
            "info": "status-info",
            "loading": "status-loading",
            "ok": "status-ok",
            "success": "status-ok",
            "warning": "status-warning",
            "biefcase": "stor-biefcase",
            "bin": "stor-bin",
            "binder": "stor-binder",
            "box": "stor-box",
            "database": "stor-database",
            "gift": "stor-gift",
            "jar": "stor-jar",
            "mailbox": "stor-mailbox",
            "package": "stor-package",
            "vault": "stor-vault",
            "bluetooth": "symbol-bluetooth",
            "rss": "symbol-rss",
            "calendar": "tool-calendar",
            "clock": "tool-clock",
            "anchor": "tool-anchor",
            "attachment": "tool-attachment",
            "axe": "tool-axe",
            "binoculars": "tool-binoculars",
            "bomb": "tool-bomb",
            "brushes": "tool-brushes",
            "bulb": "tool-bulb",
            "cable": "tool-cable",
            "candle": "tool-candle",
            "clean": "tool-clean",
            "copy": "tool-clip-copy",
            "cut": "tool-clip-cut",
            "paste": "tool-clip-paste",
            "cog": "tool-cog",
            "cogs": "tool-cogs",
            "feather": "tool-feather",
            "hammer": "tool-hammer",
            "hand": "tool-hand",
            "ink": "tool-ink",
            "link": "tool-link",
            "unlink": "tool-link-break",
            "magnifier": "tool-magnifier",
            "zoom": "tool-zoom",
            "money": "tool-money",
            "pencil": "tool-pencil",
            "tool": "tool-tool",
            "wand": "tool-wand",
            "window": "windows-blank",
            "popup": "windows-blank-dual",
        }

        if (remap[data]) data = remap[data];

        return data;
    };

    Plugin.prototype.convertThemeIcon = function(data) {
        data = this.remapThemeIcon(data);

        const remap = {
            "action-add": "plus-square",
            "action-confirm": "check",
            "action-select": "mouse-pointer",
            "app": "browser",
            "arrow-do-redo": "redo-alt",
            "arrow-do-refresh": "sync-alt",
            "arrow-do-undo": "undo-alt",
            "arrow-down": "arrow-circle-down",
            "arrow-left": "arrow-circle-left",
            "arrow-loop": "undo-alt",
            "arrow-right": "arrow-circle-right",
            "arrow-up": "arrow-circle-up",
            "browser-chrome": "chrome",
            "browser-firefox": "firefox",
            "browser-ie": "internet-explorer",
            "browser-opera": "opera",
            "browser-safari": "safari",
            "com-mail": "envelope",
            "com-phone-mobile": "mobile",
            "com-phone-smart": "mobile",
            "com-phone": "phone",
            "device-calc": "calculator",
            "device-card": "microchip",
            "device-computer-laptop": "laptop",
            "device-computer-router": "router",
            "device-computer-server": "server",
            "device-computer-tablet": "tablet",
            "device-computer": "computer-classic",
            "device-in-game": "gamepad",
            "device-in-keyboard": "keyboard",
            "device-in-mouse": "mouse",
            "device-in-tablet": "tablet",
            "device-printer": "print",
            "device-screen": "desktop",
            "device-signal": "wifi",
            "device-stor-cd": "compact-disc",
            "device-stor-disk": "save",
            "device-stor-drive": "hdd",
            "device-stor-sd": "sd-card",
            "device-stor-usb": "usb-drive",
            "edit-align-center": "align-center",
            "edit-align-justify": "align-justify",
            "edit-align-left": "align-left",
            "edit-align-right": "align-right",
            "edit-check": "spell-check",
            "edit-columns": "line-columns",
            "edit-disp-bottom": "objects-align-bottom",
            "edit-disp-center": "objects-align-center-horizontal",
            "edit-disp-left": "objects-align-left",
            "edit-disp-middle": "objects-align-center-vertical",
            "edit-disp-right": "objects-align-right",
            "edit-disp-top": "objects-align-top",
            "edit-format-bold": "bold",
            "edit-format-italic": "italic",
            "edit-format-strike": "strikethrough",
            "edit-format-underline": "underline",
            "edit-indent-less": "outdent",
            "edit-indent-more": "indent",
            "edit-list-ol": "list-ol",
            "edit-list-ul": "list-ul",
            "edit-select-all": "object-group",
            "emotion-angel": "angel",
            "emotion-devil": "ram",
            "emotion-neutral": "",
            "emotion-sad-crying": "sad-cry",
            "emotion-sad": "frown",
            "emotion-smile-big": "grin-alt",
            "emotion-smile": "smile",
            "emotion-surprise": "surprise",
            "emotion-tongue": "grin-tongue",
            "emotion-wink": "grin-wink",
            "file-book-open": "book-open",
            "file-book": "book",
            "file-certificate": "certificate",
            "file-notes": "sticky-note",
            "file-page-empty": "file",
            "file-page-find-replace": "file-search",
            "file-page-find": "file-search",
            "file-page": "file-alt",
            "file-pages": "copy",
            "file-script-alt": "scroll-old",
            "file-script": "scroll",
            "file-type-audio-wma": "music",
            "file-type-img-jpg": "image",
            "file-type-img-psd": "image",
            "file-type-img-raw": "image",
            "file-type-video-flash-swf": "film",
            "file-type-video-flash": "film",
            "file-type-video-vlc": "traffic-cone",
            "folder-documents": "folder-open",
            "folder": "folder",
            "food-cheese": "cheese-swiss",
            "food-cookie": "cookie-bite",
            "food-cup": "mug-hot",
            "food-egg": "egg",
            "food-hotdog": "hotdog",
            "food-meat": "meat",
            "food-mushroom": "seeding",
            "food-pint": "beer",
            "food-pizza": "pizza-slice",
            "food-sandwish": "sandwich",
            "food-zuchini": "pepper-hot",
            "media-art": "palette",
            "media-diapo": "presentation",
            "media-event": "calendar-check",
            "media-film": "film",
            "media-movies": "video",
            "media-music": "music",
            "media-news": "newspaper",
            "media-photos-raw": "photo-video",
            "media-photos": "image",
            "media-picture": "image-polaroid",
            "media-sound-record": "microphone",
            "media-sound": "volume",
            "media-speech": "comment-lines",
            "media-speechs": "comments",
            "media-text": "file-alt",
            "media-vcard": "id-card",
            "mod-articles": "newspaper",
            "mod-desktop": "lamp-desk",
            "mod-dev": "terminal",
            "mod-flag-lang": "language",
            "mod-flag": "flag",
            "mod-lab": "flask",
            "mod-menus": "sitemap",
            "mod-performance": "tachometer",
            "mod-rescue": "first-aid",
            "mod-settings": "sliders-h",
            "mod-stats": "chart-pie",
            "mod-tutorial": "graduation-cap",
            "mod-update": "sparkles",
            "modules": "puzzle-piece",
            "obj-clothe": "tshirt",
            "obj-game-cards": "dice",
            "os-android": "android",
            "os-apple": "apple",
            "os-linux": "linux",
            "os-windows": "windows",
            "overlay-folder-back": "folder-open",
            "overlay-folder-front": "folder-open",
            "pet-bird": "crow",
            "pet-cat": "cat",
            "pet-dog": "dog",
            "pet-fish": "fish",
            "pet-flower": "flower-tulip",
            "pet-poo": "poo",
            "pet-turtle": "turtle",
            "place-air": "plane",
            "place-autos": "car",
            "place-boat": "ship",
            "place-cloud": "cloud",
            "place-home": "house",
            "place-map-marker": "map-marker-alt",
            "place-map": "map",
            "place-office": "building",
            "place-space": "rocket",
            "place-tree": "tree",
            "place-unknow": "landmark",
            "place-wall-fence": "dungeon",
            "place-wall": "dungeon",
            "place-world": "globe-americas",
            "secure-anonymus": "user-secret",
            "secure-key": "key",
            "secure-keys": "key",
            "secure-lock-open": "lock-open",
            "secure-lock": "lock",
            "secure-trafic": "traffic-light-stop",
            "secure-user-active": "user-check",
            "secure-user-disabled": "user-slash",
            "secure-user": "user",
            "secure-users": "users",
            "shape-bloc": "cube",
            "shape-cross": "times",
            "shape-feets": "paw",
            "shape-fire": "fire",
            "shape-heart": "heart",
            "shape-lightning": "bolt",
            "shape-star": "star",
            "shape-target": "bullseye-arrow",
            "status-bug": "bug",
            "status-denied": "do-not-enter",
            "status-error": "times-hexagon",
            "status-help": "question-circle",
            "status-info": "info-circle",
            "status-loading": "hourglass-half",
            "status-ok": "check-circle",
            "status-warning": "exclamation-triangle",
            "stor-biefcase": "briefcase",
            "stor-bin-full": "trash",
            "stor-bin": "trash",
            "stor-binder": "books",
            "stor-box": "box",
            "stor-database": "database",
            "stor-gift": "gift",
            "stor-jar": "",
            "stor-mailbox": "mailbox",
            "stor-package": "box-full",
            "stor-vault": "lock",
            "symbol-bluetooth": "bluetooth",
            "symbol-rss": "rss",
            "time-calendar": "calendar",
            "time-clock": "clock",
            "tool-anchor": "anchor",
            "tool-attachment": "paperclip",
            "tool-axe": "axe",
            "tool-binoculars": "binoculars",
            "tool-bomb": "bomb",
            "tool-brushes": "brush",
            "tool-bulb-off": "lightbulb-slash",
            "tool-bulb-on": "lightbulb",
            "tool-bulb": "lightbulb",
            "tool-cable": "ethernet",
            "tool-candle": "candle-holder",
            "tool-clean": "broom",
            "tool-clip-copy": "copy",
            "tool-clip-cut": "cut",
            "tool-clip-paste": "paste",
            "tool-cog": "cog",
            "tool-cogs": "cogs",
            "tool-feather": "feather",
            "tool-hammer": "hammer",
            "tool-hand": "hand-paper",
            "tool-ink": "tint",
            "tool-link-break": "unlink",
            "tool-link": "link",
            "tool-magnifier": "search",
            "tool-money": "sack-dollar",
            "tool-pencil": "pencil",
            "tool-tool": "wrench",
            "tool-wand": "magic",
            "windows-blank-dual": "window-restore",
            "windows-blank": "window-maximize",
        }

        if (remap[data]) data = 'fa-'+remap[data];
        return data;
    }

    Plugin.prototype.getColorIcon = function (data) {
        const $svg = '<?xml version="1.0"?><svg height="600" width="600" xmlns="http://www.w3.org/2000/svg"><circle cx="50%" cy="50%" r="46%" fill="' + data + '" /><circle cx="50%" cy="50%" r="45%" stroke="rgba(0,0,0,0.5)" stroke-width="20" fill="none" /></svg>';
        return 'data:image/svg+xml;base64,' + btoa($svg);
    };

    Plugin.prototype.getGalerieImage = function (data, size, index) {
        var selfIcon = this;
        ajaxForm({
            url: 'api/galeries/image/' + data + '/',
            method: 'GET',
            messages: false,
            callback: function (data, form) {
                selfIcon.options.data[index] = {
                    "src": data.data.url_th,
                    "alt": data.data.name
                }
                selfIcon.data = selfIcon.format(selfIcon.options);
                selfIcon.renderMulti();
            }
        });
    }

    Plugin.prototype.getFileTypeIcon = function (type) {
        let $meta;
        switch (type) {
            case 'folder':
                $meta = {
                    'name': __('Dossier'),
                    'fa': 'fa-folder-open',
                    'icon': 'folder',
                    'group': 'folder'
                };
                break;
            case 'doc':
            case 'docx':
                $meta = {
                    'name': __('Document Word'),
                    'fa': 'fa-file-word',
                    'icon': 'file-page',
                    'group': 'text'
                };
                break;
            case 'url':
                $meta = {
                    'name': __('Lien'),
                    'fa': 'fa-file-alt',
                    'icon': 'place-world',
                    'group': 'url'
                };
                break;
            case 'txt':
                $meta = {
                    'name': __('Document texte'),
                    'fa': 'fa-file-alt',
                    'icon': 'file-page',
                    'group': 'text'
                };
                break;
            case 'rtf':
                $meta = {
                    'name': __('Document Rich text'),
                    'fa': 'fa-file-alt',
                    'icon': 'file-page',
                    'group': 'text'
                };
                break;
            case 'xls':
            case 'xlsx':
                $meta = {
                    'name': __('Tableur excel'),
                    'fa': 'fa-file-excel',
                    'icon': 'mod-stats',
                    'group': 'text'
                };
                break;
            case 'csv':
                $meta = {
                    'name': __('Tableur CSV'),
                    'fa': 'fa-file-csv',
                    'icon': 'mod-stats',
                    'group': 'text'
                };
                break;
            case 'ppt':
            case 'pptx':
            case 'ppsx':
            case 'pps':
                $meta = {
                    'name': __('Diaporama PowerPoint'),
                    'fa': 'fa-file-powerpoint',
                    'icon': 'media-diapo',
                    'group': 'text'
                };
                break;
            case 'zip':
            case 'rar':
            case 'cab':
            case 'tar':
            case 'gz':
            case '7z':
                $meta = {
                    'name': __('Dossier compressé'),
                    'fa': 'fa-file-archive',
                    'icon': (type == 'rar') ? 'file-type-archive-rar' : 'stor-box',
                    'group': 'archive'
                };
                break;
            case 'php':
            case 'js':
            case 'asp':
            case 'cp':
            case 'c':
            case 'h':
            case 'css':
            case 'scss':
                $meta = {
                    'name': __('Script') + ' ' + type,
                    'fa': 'fa-file-code',
                    'icon': 'file-script',
                    'group': 'script'
                };
                break;
            case 'exe':
                $meta = {
                    'name': __('Application Windows'),
                    'fa': 'fa-file-exclamation',
                    'icon': 'os-windows',
                    'group': 'app'
                };
                break;
            case 'app':
                $meta = {
                    'name': __('Application Mac'),
                    'fa': 'fa-file-exclamation',
                    'icon': 'os-apple',
                    'group': 'app'
                };
                break;
            case 'apk':
                $meta = {
                    'name': __('Application Android'),
                    'fa': 'fa-file-exclamation',
                    'icon': 'os-android',
                    'group': 'app'
                };
                break;
            case 'mp4':
            case 'mov':
            case 'avi':
            case 'mpg':
            case 'mpeg':
            case 'mkv':
                $meta = {
                    'name': __('Vidéo') + ' ' + type,
                    'fa': 'fa-file-video',
                    'icon': 'media-movies',
                    'group': 'video'
                };
                break;
            case 'mp3':
            case 'ogg':
            case 'flac':
            case 'mid':
                $meta = {
                    'name': __('Musique') + ' ' + type,
                    'fa': 'fa-file-music',
                    'icon': 'media-music',
                    'group': 'audio'
                };
                break;
            case 'wav':
            case 'voc':
            case 'aif':
                $meta = {
                    'name': __('Effet sonore') + ' ' + type,
                    'fa': 'fa-file-audio',
                    'icon': 'media-sound-record',
                    'group': 'audio'
                };
                break;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'ico':
                $meta = {
                    'name': __('Image') + ' ' + type,
                    'fa': 'fa-file-image',
                    'icon': 'file-type-img-jpg',
                    'group': 'image'
                };
                break;
            case 'svg':
                $meta = {
                    'name': __('Dessin') + ' ' + type,
                    'fa': 'fa-file-image',
                    'icon': 'file-notes',
                    'group': 'image'
                };
                break;
            case 'bmp':
            case 'tif':
            case 'tiff':
            case 'cr2':
            case 'nef':
            case 'psd':
                $meta = {
                    'name': __('Image') + ' ' + type,
                    'fa': 'fa-file-image',
                    'icon': 'file-type-img-psd',
                    'group': 'graphic'
                };
                break;
            case 'ai':
            case 'eps':
                $meta = {
                    'name': __('Dessin') + ' ' + type,
                    'fa': 'fa-file-image',
                    'icon': 'file-notes',
                    'group': 'graphic'
                };
                break;
            case 'pdf':
                $meta = {
                    'name': __('Document PDF') + ' ' + type,
                    'fa': 'fa-file-pdf',
                    'icon': 'file-page-find-replace',
                    'group': 'text'
                };
                break;
            default:
                $meta = {
                    'name': 'Fichier',
                    'fa': 'fa-file',
                    'icon': 'file-page-empty'
                };
        }
        return $meta;
    }

    Plugin.prototype.convertSvg = function () {
        var selfIcon = this;
        setTimeout(function () {
            var output = $('#' + selfIcon.id);
            imgToSvg(output, true);
        }, 50)
    }

    Plugin.prototype.afterRender = function (data, uid) {
        var selfIcon = this;
        var output = $('[data-id=' + uid + ']');
        var outputIv = output.closest('.iv__item__image');
        var outputImg = output.find('.ico__img');

        if (data.ext == 'png' && data.autofit) {
            getImageLightness(data.src, function (brightness, hasAlpha) {
                var specs = [];

                if (hasAlpha) specs.push('transparent');
                if (!hasAlpha) specs.push('opaque');
                if (brightness > 150) specs.push('dark');
                else specs.push('light');

                $.each(specs, function (index, spec) {
                    output.addClass('ico--' + spec);
                    outputIv.addClass('iv__item__image--' + spec);
                });
            })
        }

        if (outputImg.length) {
            if (selfIcon.data.data[0].file.indexOf('icons') != -1) {
                output.addClass('ico--scare');
                this.convertSvg();
            } else {
                var dummy = $("<img>").attr("src", outputImg.attr("src"));
                if (dummy.complete || outputImg.prop("tagName") == 'svg') {
                    this.afterImgLoad(data, uid, dummy[0].width, dummy[0].height);
                } else {
                    dummy.on('load', () => {
                        setTimeout(() => {
                            this.afterImgLoad(data, uid, dummy[0].width, dummy[0].height);
                        }, 100)
                    })
                }
            }
        }
    }

    Plugin.prototype.afterImgLoad = function (data, uid, width, height) {
        var selfIcon = this;
        var output = $('[data-id=' + uid + ']');
        var outputIv = output.closest('.iv__item__image');
        var outputImg = output.find('.ico__img');

        if (width > 1200) {
            output.addClass('ico--xlarge');
        }

        if (width == height) {
            output.addClass('ico--scare');
            this.convertSvg();
        } else if (width > height) {
            output.addClass('ico--landscape');
        } else {
            output.addClass('ico--portrait');
        }
    }

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (a, b) {
        let action, options;
        if (typeof a === 'string') {
            action = a;
            options = b;
        } else {
            action = 'init';
            options = a;
        }

        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            } else {
                $.data(this, 'plugin_' + pluginName).action(action, options);
            }
        });
    };

})(jQuery, window, document);
